import { createSlice } from "redux-starter-kit";


const initialState = { open: false, options: {} };
const signupOverlay = createSlice({
    slice: "signupOverlay",
    initialState,
    reducers: {
        openSignupOverlay(state, { payload }) {
            state.open = true;
            state.options = payload;
        },
        closeSignupOverlay(state) {
            state.open = false;
            state.options = {};
        },
    },
});

// Extract the action creators object and the reducer
const { actions, reducer } = signupOverlay;
// Extract and export each action creator by name
export const { openSignupOverlay, closeSignupOverlay } = actions;
// Export the reducer, either as a default or named export
export default reducer;
